import React, { useState } from 'react'
import httpService from 'services/httpService';
import displayGlobalMessage, { toastConfig } from 'Utils/DisplayGlobalMessage';
import log from "loglevel";
import * as constants from "Constants";
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import fileDownload from 'js-file-download';
import FieldSelectionModal from './FieldSelectionModal';



const DownloadSingleProgrammingActivityCSV = ({
    as: Component = "div",
    program_id,
    activityTitle,
    lab_title = "",
    lab_Id = "",
    zipFormat = false,
    csvFormat = false,
    disabled,
    children = <div>Download All Submissions</div>,
    className = "flex gap-2 align-items-center justify-content-center",
    ...props
}) => {
    const [showFieldSelectionModal, setShowFieldSelectionModal] = useState(false);

    const handleOpenModal = () => {
        if (disabled) {
            displayGlobalMessage('No submissions to download', 'error');
            return;
        }
        setShowFieldSelectionModal(true);
    };

    const handleCloseModal = () => {
        setShowFieldSelectionModal(false);
    };

    const [downloading, setDownlading] = useState(false);

    const downloadAllSubmissionsCSV = async (e, columns_to_send) => {
        if (downloading) {
            displayGlobalMessage("Download is in progress ... ", "info");
            return;
        };
        const url = constants.base_url + "/evalpro/submissions/download_csv/" + program_id;
        let toastId = "";
        try {
            toastId = toast.loading(
                `Fetching data for ${activityTitle || program_id}`,
                toastConfig
            );
            setDownlading(true);
            const response = await httpService.post(url, { columns_to_send }, { responseType: "blob" });
            if (response.data instanceof Blob) {
                const text = await response.data.text();
                try {
                    const json = JSON.parse(text);
                    log.log({ json });
                    if (json?.message) {
                        toast.update(toastId, {
                            render: `${json.message}`,
                            type: "info",
                            autoClose: 5000,
                            closeOnClick: true,
                            draggable: true,
                            hideProgressBar: false,
                            isLoading: false
                        });
                    } else {
                        log.error("Unexpected JSON structure:", json);
                        toast.update(toastId, {
                            render: `Unexpected response received for ${activityTitle}. Contact developers.`,
                            type: "error",
                            autoClose: 5000,
                            closeOnClick: true,
                            draggable: true,
                            hideProgressBar: false,
                            isLoading: false
                        });
                    }
                } catch (e) {
                    fileDownload(
                        response.data,
                        lab_title?.replaceAll(" ", "_") + "_" + activityTitle?.replaceAll(" ", "_") + "_Submissions.csv"
                    );
                    toast.update(toastId, {
                        render: `The download was initiated successfully for ${activityTitle}`,
                        type: "success",
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                        hideProgressBar: false,
                        isLoading: false
                    });
                }
            } else {
                log.error("Unexpected response format:", response.data);
                toast.update(toastId, {
                    render: `Unexpected response format received for ${activityTitle}, please contact developers`,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    draggable: true,
                    hideProgressBar: false,
                    isLoading: false
                });
            }
        } catch (err) {
            log.error("Error during download:", err);
            log.error(err);
            log.error(err?.response);
            toast.update(toastId, {
                render: `Couldn't download the file for ${activityTitle} ${err?.response?.statusText ? `(${err.response.statusText})` : ''}`,
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                draggable: true,
                hideProgressBar: false,
                isLoading: false
            });
        } finally {
            setDownlading(false);
        }
    };

    const downloadAllSubmissionsZip = async (e) => {
        if (disabled) {
            displayGlobalMessage('No submissions to download', 'error');
            return;
        }
        if (downloading) return;
        const FileDownload = require("js-file-download");
        var url = constants.base_url + "/evalpro/submissions/download_zip/" + program_id;

        let toastId = "";
        try {
            setDownlading(true);
            toastId = toast.loading(
                `Fetching data for ${activityTitle || program_id}`,
                toastConfig
            );
            const response = await httpService.instance({
                url,
                method: "GET",
                responseType: "blob", // Important
            });

            if (response.data instanceof Blob) {
                const text = await response.data.text();
                try {
                    const json = JSON.parse(text);
                    if (json?.message) {
                        toast.update(toastId, {
                            render: `${json.message}`,
                            type: "info",
                            autoClose: 5000,
                            closeOnClick: true,
                            draggable: true,
                            hideProgressBar: false,
                            isLoading: false
                        });
                    } else {
                        toast.update(toastId, {
                            render: "Unexpected response received. Contact developers.",
                            type: "error",
                            autoClose: 5000,
                            closeOnClick: true,
                            draggable: true,
                            hideProgressBar: false,
                            isLoading: false
                        });
                    }
                } catch (err) {
                    FileDownload(response.data, "Submissions_" + program_id + ".zip");
                    toast.update(toastId, {
                        render: "The download was initiated successfully!",
                        type: "success",
                        autoClose: 5000,
                        closeOnClick: true,
                        draggable: true,
                        hideProgressBar: false,
                        isLoading: false
                    });
                }
            } else {
                log.error("Unexpected response format:", response.data);
                toast.update(toastId, {
                    render: "Unexpected response format received, please contact developers",
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    draggable: true,
                    hideProgressBar: false,
                    isLoading: false
                });
            }
        } catch (err) {
            log.error(err);
            log.error(err?.response);
            toast.update(toastId, {
                render: `Couldn't download the file ${err?.response?.statusText ? `(${err.response.statusText})` : ''}`,
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                draggable: true,
                hideProgressBar: false,
                isLoading: false
            });
        } finally {
            setDownlading(false)
        }
    };
    return (
        <>
            <Component
                className={className}
                disabled={disabled || downloading}
                onClick={zipFormat ? downloadAllSubmissionsZip : csvFormat ? handleOpenModal : null}
                {...props}
            >
                {downloading ? <Spinner size="sm" animation="border" /> : null}
                {children}
            </Component>
            <FieldSelectionModal
                show={showFieldSelectionModal}
                onHide={handleCloseModal}
                downloadFunction={zipFormat ? downloadAllSubmissionsZip : csvFormat ? downloadAllSubmissionsCSV : null}
                lab_Id={lab_Id} // for rereading
            />
        </>
    )
}

export default DownloadSingleProgrammingActivityCSV